import {useLocation, useNavigate} from "react-router-dom";
import {Box, Flex, Image, Text, Stack, useMediaQuery} from "@chakra-ui/react";
import {ACCESS_TOKEN_KEY, routes} from "../../utils/constants";
import NavItem from "../../components/navbar/NavItem";
import Cookies from "js-cookie";
import {scrollbar} from "../../utils/helper";
import {APPS, shortcutApps} from "../../utils/recentApps";
const padding = {base: "16px", md: "24px"};

function SidebarTitle() {
    const navigate = useNavigate();
    return <Flex
        alignItems={"center"}
        onClick={() => navigate("/")}
        cursor={"pointer"}
        gap={3}
        px={padding}
    >
        <Image src="/images/load-logo.svg" />
        <Text color={"primary.900"} fontWeight={"bold"}>
            Load Management
        </Text>
    </Flex>;
}

export default function Sidebar() {
    const router = useLocation();
    const [isLargeScreen] = useMediaQuery(`(min-width: 768px)`);
    return <Stack
        data-cy="sidebar"
        flexDirection={"column"}
        justifyContent={"space-between"}
        w={{base: "100%", md: "310px"}}
        h={"100dvb"}
        pt={{base: "16px"}}
        pb={{base: "16px"}}
        boxShadow={"0px 2px 8px -1px rgba(27, 36, 44, 0.12)"}
    >
        <SidebarTitle/>
        <Flex mt={"24px"} gap="8px" flexDir="column" flex={"2 1 auto"} overflowY="auto" px={padding} sx={isLargeScreen ? scrollbar.styled : scrollbar.hidden}>
            {routes.map((props, i) => (
                <NavItem
                    key={i + 1}
                    {...props}
                    active={router.pathname.includes(props.href)}
                />
            ))}
        </Flex>
        <Text
            color={"primary.900"}
            fontWeight={500}
            fontSize={"12px"}
            lineHeight={"18px"}
            py={2.5}
            px={padding}
        >
            Shortcuts
        </Text>
        <Flex gap={"16px"} w={"100%"} px={padding}>
            {shortcutApps().map(app => <Box
                key={app.key}
                w={"72px"}
                h={"72px"}
                borderRadius={"12px"}
                bg={"#fff"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                boxShadow={"0px 4px 13px 0px #0000000F"}
                title={APPS[app.key].name}
            >
                <Image
                    src={APPS[app.key].icon}
                    alt={APPS[app.key].name}
                    data-cy={`shortcut-${app.key}`}
                    w={"40px"}
                    h={"40px"}
                    onClick={() => {
                        window.open(
                            `${app.url}?token=${Cookies.get(ACCESS_TOKEN_KEY)}`,
                            "_self"
                        );
                    }}
                    cursor={"pointer"}
                />
            </Box>)}
        </Flex>
    </Stack>;
}
